// Constantes partagées du module Boîte à Idées (miroir des valeurs backend routes/ideas.py)

export const IDEA_CATEGORIES = [
    { value: 'performance_commerciale', label: 'Performance commerciale', desc: "Ventes, closing, scripts, offres, productivité commerciale." },
    { value: 'management_animation', label: 'Management & Animation des équipes', desc: "Pilotage, motivation, organisation et accompagnement des équipes." },
    { value: 'recrutement_onboarding', label: 'Recrutement & Onboarding', desc: "Recrutement, intégration et montée en compétence des nouveaux." },
    { value: 'process_organisation', label: 'Process & Organisation', desc: "Simplifier, accélérer ou fiabiliser le fonctionnement global." },
    { value: 'communication_marketing', label: 'Communication & Marketing', desc: "Réseaux sociaux, contenus, image de marque, supports, visibilité." },
    { value: 'experience_client', label: 'Expérience Client', desc: "Compréhension, satisfaction et suivi des clients." },
    { value: 'offres_developpement', label: 'Offres & Développement', desc: "Nouveaux services, marchés, offres et opportunités." },
    { value: 'culture_excellence', label: 'Culture & Excellence Opérationnelle', desc: "Standards, valeurs, discipline et excellence collective." },
    { value: 'partenariats_reseau', label: 'Partenariats & Développement Réseau', desc: "Apporteurs, partenaires et relations externes." },
    { value: 'autres_strategiques', label: 'Autres idées stratégiques', desc: "Toute proposition hors catégories précédentes." },
];

export const CATEGORY_LABELS = Object.fromEntries(IDEA_CATEGORIES.map((c) => [c.value, c.label]));

export const IDEA_IMPACTS = [
    { value: 'faible', label: 'Faible' },
    { value: 'moyen', label: 'Moyen' },
    { value: 'fort', label: 'Fort' },
    { value: 'transformateur', label: 'Transformateur' },
];

export const IDEA_EASES = [
    { value: 'facile', label: 'Facile' },
    { value: 'moyenne', label: 'Moyenne' },
    { value: 'complexe', label: 'Complexe' },
];

export const IDEA_STATUSES = {
    en_attente: { label: 'En attente', badge: 'bg-slate-100 text-slate-700 border-slate-200', dot: 'bg-slate-400' },
    a_l_etude: { label: "À l'étude", badge: 'bg-blue-50 text-blue-700 border-blue-200', dot: 'bg-blue-500' },
    acceptee: { label: 'Acceptée', badge: 'bg-emerald-50 text-emerald-700 border-emerald-200', dot: 'bg-emerald-500' },
    refusee: { label: 'Refusée', badge: 'bg-red-50 text-red-700 border-red-200', dot: 'bg-red-500' },
    en_deploiement: { label: 'En déploiement', badge: 'bg-amber-50 text-amber-700 border-amber-200', dot: 'bg-amber-500' },
    mise_en_oeuvre: { label: 'Mise en œuvre', badge: 'bg-violet-50 text-violet-700 border-violet-200', dot: 'bg-violet-500' },
    archivee: { label: 'Archivée', badge: 'bg-slate-100 text-slate-500 border-slate-200', dot: 'bg-slate-300' },
};

export const STATUS_ORDER = ['en_attente', 'a_l_etude', 'acceptee', 'refusee', 'en_deploiement', 'mise_en_oeuvre', 'archivee'];

export const IMPACT_LABELS = Object.fromEntries(IDEA_IMPACTS.map((i) => [i.value, i.label]));
export const EASE_LABELS = Object.fromEntries(IDEA_EASES.map((i) => [i.value, i.label]));

export const fmtDate = (iso) => {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch { return ''; }
};
